import { useAuth } from '../context/AuthContext';
import { useState, useEffect } from 'react';

export default function BalanceDisplay() {
  const { user, refreshUser, refreshRobloxBalance } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  // Refresh user data and Roblox balance periodically
  useEffect(() => {
    // Initial Roblox balance refresh
    if (user?.roblox_user_id && refreshRobloxBalance) {
      refreshRobloxBalance();
    }
    
    const interval = setInterval(() => {
      if (refreshUser) refreshUser();
      if (user?.roblox_user_id && refreshRobloxBalance) {
        refreshRobloxBalance();
      }
    }, 30000); // Refresh every 30 seconds
    
    return () => clearInterval(interval);
  }, [user?.roblox_user_id]);

  if (!user) return null;

  const siteBalance = user.site_balance || 0;
  const robloxBalance = user.roblox_balance || 0;
  const totalBalance = siteBalance + robloxBalance;

  return (
    <div
      className="relative"
      onMouseEnter={() => setShowDropdown(true)}
      onMouseLeave={() => setShowDropdown(false)}
      data-testid="balance-display"
    >
      <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-slate-800/80 border border-slate-700/50 cursor-pointer transition-all hover:border-green-500/30">
        <div className="w-5 h-5 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center">
          <span className="text-[10px] font-bold text-white">R$</span>
        </div>
        <div className="flex flex-col">
          <span className="font-mono font-bold text-sm text-green-400" data-testid="balance-amount">
            {siteBalance.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
          <span className="text-[10px] text-slate-500">Balance</span>
        </div>
      </div>

      {/* Hover Dropdown */}
      <div className={`absolute top-full left-1/2 -translate-x-1/2 mt-2 p-3 rounded-lg bg-slate-900 border border-slate-700 text-sm whitespace-nowrap z-50 transition-all duration-200 ${
        showDropdown ? 'opacity-100 visible' : 'opacity-0 invisible'
      }`}>
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between gap-4">
            <span className="text-slate-400">Site Balance:</span>
            <span className="font-mono text-green-400">R$ {siteBalance.toLocaleString()}</span>
          </div>
          <div className="flex items-center justify-between gap-4">
            <span className="text-slate-400">Roblox Balance:</span>
            <span className="font-mono text-blue-400">R$ {robloxBalance.toLocaleString()}</span>
          </div>
          <div className="border-t border-slate-700 pt-2 mt-1">
            <div className="flex items-center justify-between gap-4">
              <span className="text-slate-300 font-medium">Total:</span>
              <span className="font-mono text-white font-bold">R$ {totalBalance.toLocaleString()}</span>
            </div>
          </div>
        </div>
        <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-slate-900 border-l border-t border-slate-700 rotate-45" />
      </div>
    </div>
  );
}
